export const FETCH_GET_CHECKLIST = 'FETCH_GET_CHECKLIST';
export const FETCH_CREATE_CHECKLIST = 'FETCH_CREATE_CHECKLIST';
export const FETCH_TOGGLE_CHECKLIST = 'FETCH_TOGGLE_CHECKLIST';
export const FETCH_UPDATE_CHECKLIST = 'FETCH_UPDATE_CHECKLIST';
export const FETCH_DELETE_CHECKLIST = 'FETCH_DELETE_CHECKLIST';
